import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
// import { on } from 'element-ui/src/utils/dom';
//

/* istanbul ignore next */
var on = function () {
  if (!Vue.prototype.$isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/***
 * 点击元素外处理函数
 * 父元素下， 当在有特殊类名的元素外点击时 会触发处理函数 ，点击包含了特色类名的父元素也会触发元素外处理函数
 *
 * @type {*[]}
 */
var nodeList = [];
var ctx = '@@clickoutsideContext';
var startClick;
var seed = 0;
!Vue.prototype.$isServer && on(document, 'mousedown', function (e) {
  return startClick = e;
});
!Vue.prototype.$isServer && on(document, 'mouseup', function (e) {
  // console.log('mouseup')
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

// 获取父元素下有特殊类名的元素
function ifHasArea(el, area) {
  if (!area) return false;
  return el.getElementsByClassName(area);
}

// 轮询父元素下的有特殊类名的元素 判断是不是e.target 或者包含了e.target

function ifInArea(eles, target1, target2) {
  for (var i = 0; i < eles.length; i++) {
    var el = eles[i];
    if (el.contains(target1) || el.contains(target2) || el === target1) return true;
  }
}
function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var elems = ifHasArea(el, el[ctx].effectAreas);

    // 当存在特殊类名
    if (elems) {
      if (ifInArea(elems, mousedown.target, mouseup.target)) {
        return;
      }

      // 没有则父元素下的所有元素都响应
    } else if (el.contains(mousedown.target) || el.contains(mouseup.target) || el === mousedown.target) {
      return;
    }
    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
export default {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value,
      effectAreas: binding.arg
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
    el[ctx].effectAreas = binding.arg;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;
    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};